import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    CampaignsModuleName,
    CampaignsServiceModuleName,
    CardConfigModuleName
} from "../utils/names/optionalModuleNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {CampaignControllerName} from "../utils/names/controllerNames";
import {CampaignServiceName} from "../utils/names/serviceNames";
import {CampaignService} from "../campaigns_service/service/CampaignService";
import {LoaderStatusValue} from "../loader/service/loaderStatus";
import {ContactType} from "../contact/model/Contact";
import {CampaignType} from "modules/campaigns_service/model/CampaignType";
import {getTabName} from "modules/utils/TabNameUtils";

export const CampaignsModuleConfiguration = new RestrictedRouteModuleConfiguration(CampaignsModuleName,
    [
        CampaignsModuleName,
        CampaignsServiceModuleName,
        CardConfigModuleName
    ],
    [[
        '/campaigns', {
            template: require('./route/campaigns.controller.html'),
            controller: CampaignControllerName,
            controllerAs:'$ctrl',
            resolve: {
                campaignConfigs: [CampaignServiceName, 'LoaderStatusValue',
                    function (campaignService: CampaignService, loaderStatus: LoaderStatusValue) {
                        loaderStatus.on();
                        return campaignService.fetchLoggedInUserCampaignToggles()
                            .then(resp => {
                                loaderStatus.off();
                                return resp.data.filter(c => c.clientType == ContactType.CUSTOMER && c.type != CampaignType.TBD);
                            });
                    }
                ],
                campaignLeadConfigs: [CampaignServiceName, 'LoaderStatusValue',
                    function (campaignService: CampaignService, loaderStatus: LoaderStatusValue) {
                        loaderStatus.on();
                        return campaignService.fetchLoggedInUserCampaignToggles()
                            .then(resp => {
                                loaderStatus.off();
                                return resp.data.filter(c => c.clientType == ContactType.LEAD);
                            });
                    }
                ],
                campaignPartnerConfigs: [CampaignServiceName, 'LoaderStatusValue',
                    function (campaignService: CampaignService, loaderStatus: LoaderStatusValue) {
                        loaderStatus.on();
                        return campaignService.fetchLoggedInUserCampaignToggles()
                            .then(resp => {
                                loaderStatus.off();
                                return resp.data.filter(c => c.clientType == ContactType.PARTNER);
                            });
                    }
                ],
                campaignLoanOfficerConfigs: [CampaignServiceName, 'LoaderStatusValue',
                    function (campaignService: CampaignService, loaderStatus: LoaderStatusValue) {
                        loaderStatus.on();
                        return campaignService.fetchLoggedInUserCampaignToggles()
                            .then(resp => {
                                loaderStatus.off();
                                return resp.data.filter(c => c.clientType == ContactType.LOAN_OFFICER);
                            });
                    }
                ]
            }
        }]],
    [new NavigationItem({
        title: 'Campaigns',
        href: '#!campaigns',
        accessRole: [NavigationAccessRoles.ROLE_USER],
        activeFunction: (name) => {
            return name.indexOf("campaigns") != -1;
        }
    })],
    [CampaignsModuleName],
    [UserGranredAuthorityName.CAMPAIGNS],
    getTabName() + '| Campaigns'
);

export default CampaignsModuleConfiguration;
